var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 1000,
    viewBox: "0 0 1001 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.598 0C107.718 0 70.43 15.4451 42.9376 42.9375C15.4451 70.43 0 107.718 0 146.598L0 1000H211.044V211.044H999.97V0H146.598Z",
    fill: "url(#paint0_linear_244_1322)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.976 262.965V999.999H853.473C892.353 999.999 929.641 984.554 957.133 957.062C984.626 929.569 1000.07 892.281 1000.07 853.401V525.78H525.792V736.824H788.728V788.716H474.14V474.128H1000.19V263.084L262.976 262.965Z",
    fill: "url(#paint1_linear_244_1322)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_244_1322",
    x1: 999.97,
    y1: 0.0000596063,
    x2: -0.0317926,
    y2: 1000.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FEC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E24"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_244_1322",
    x1: 1000.19,
    y1: 262.965,
    x2: 263.155,
    y2: 1000.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FEC900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1802e43da20dc58f867c3d39f6da3a09.svg";
export { ForwardRef as ReactComponent };